<template>
  <div class="vip-packages-toast"
    :data-theme="vipPackToastName"
    :class="'theme-' + vipPackToastName"
  >
    <!-- 弹窗样式 -->
    <div
     v-if="vipPackToastName=== 'disableAd'"
     class="disableAd-wrapper content-wrapper"
     v-log="{
      event_type: 'show',
      event_name: '会员弹窗-展示',
      event_data: {
        name: '开通成功',
      },
     }">
      <div class="confirm-btn">
        <img src="https://qncweb-back1.ktvsky.com/20221011/other/a21b5f63d719cbdc1fe7bf05f4a4e6d7.png" alt="" @click="handlerConfirmBtnClick(1)">
        <img src="https://qncweb-back1.ktvsky.com/20221011/other/e4250c7a2005f179246b5584a2e78c6c.png" alt="" @click="handlerConfirmBtnClick(2)">
      </div>
    </div>
    <!-- 弹窗样式 end -->
    <!-- 轮播样式 -->
    <div v-else class="content-wrapper" @click="handleClickGold">
      <div v-if="swiperData[vipPackToastName]" class="swiper-wrappper">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, index) in swiperData[vipPackToastName]" :key='index'>
            <img :src="item">
          </swiper-slide>
          <div
            v-if="swiperData[vipPackToastName].length>1"
            class="swiper-pagination"
            slot="pagination"
          >
          </div>
        </swiper>
      </div>
      <div class="pay-button" @click="handleClickGold">
        <img src="./static/button_gold.png">
      </div>
    </div>
    <!-- 轮播样式 end -->
    <div class="close" @click="handleClickClose">
      <img src="https://qncweb-back1.ktvsky.com/20221011/other/2a8ce8335ce2b2e98ba8fef15454be42.png">
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { reportPay } from '@/libs/utils/log/log';
import mixinOldVip from '@/mixins/vip-toast-test';
import { utils } from '@/libs/interfaces';
import { VipToastSwiper } from './static/index';

const STATISTIC = {
  gold: {
    pay_enter: 'openvipsuccess',
    name: '新会员开通成功弹窗',
  },
  disableAd: {
    pay_enter: 'openvipsuccess',
    name: '新会员开通成功弹窗',
  },
};
export default {
  mixins: [mixinOldVip],
  data() {
    return {
      swiperOption: {
        pagination: { el: '.swiper-pagination' },
        preventLinksPropagation: false,
        watchOverflow: true,
        loop: true,
        autoplay: { disableOnInteraction: false },
      },
      enterTime: 0,
      swiperData: VipToastSwiper,
      packages: [],
    };
  },
  computed: {
    ...mapState({
      vipPackToastName: (state) => state.vip.vipPackToastName,
    }),
    page_tp() {
      return STATISTIC[this.vipPackToastName].pay_enter;
    },
  },
  methods: {
    handlerConfirmBtnClick(index) {
      this.$sendLog({
        event_type: 'click',
        event_name: `会员弹窗-${index === 1 ? '下次再说' : '马上开启'}`,
        event_data: {
          page: '开通成功',
        },
      });
      utils.cookie.setCookie(1, 0.5, 'disableAd')
      this.$store.commit('SET_VIP_PACKAGES_TOAST');
    },
    sendLog(item) {
      this.$sendLog({
        event_type: 'click',
        event_name: `${item.desc}点击开通按钮`,
        event_data: {
          page: STATISTIC[this.vipPackToastName].name,
        },
      });
    },
    handleClickClose() {
      this.$store.commit('SET_VIP_PACKAGES_TOAST');
    },
    handlePageUnload() {
      if (this.vipPackToastName === 'gold') {
        reportPay({
          page_tp: 'openvipsucces',
          active_tp: 1, // 用户行为：0：点击 ;1：停留
          stay_time: Date.now() - this.enterTime, // 停留时间(单位：毫秒)
          source: 1,
        });
        return;
      }
      reportPay({
        page_tp: this.page_tp,
        active_tp: 1, // 用户行为：0：点击 ;1：停留
        stay_time: Date.now() - this.enterTime, // 停留时间(单位：毫秒)
      });
    },
    buyVipPlus(item) {
      utils.util.buyVipPlus({
        memberId: item.pkg_id,
        pay_fee: item.current_fee,
        pay_enter: this.page_tp,
        $this: this,
        callback: () => {
          // 新三档支付成功弹窗在util里处理
        //   this.$store.commit('SET_VIP_PACKAGES_TOAST');
        },
      });
    },
    handleClickGold() {
      utils.util.openGoldVip({
        $this: this,
        name: 'vipSuccess',
      });
      this.$sendLog({
        event_type: 'click',
        event_name: '变身金主按钮',
        event_data: {
          data: 'vip开通成功弹窗 | 支持金主',
        },
      });
      reportPay({
        page_tp: 'openvipsucces',
        active_tp: 0, // 用户行为：0：点击 ;1：停留
        source: 1, // 金主上报
      });
    },
  },
  async mounted() {
    this.enterTime = Date.now();
    await this.$nextTick();
    if (this.vipPackToastName === 'gold') {
      reportPay({
        page_tp: 'openvipsucces',
        active_tp: 3,
        source: 1, // 金主上报
      });
    } else {
      reportPay({
        page_tp: this.page_tp,
        active_tp: 3,
      });
    }
    this.$sendLog({
      event_type: 'show',
      event_name: STATISTIC[this.vipPackToastName].name,
    });
    window.addEventListener('beforeunload', this.handlePageUnload);
  },
};
</script>

<style lang="scss" scoped>
.debug {
  border: 1px solid pink;
}
$themes: (
  gold: (
    bullet: #8B7555,
    bullet-active: #090602
  )
);
.vip-packages-toast {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.80);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  &.theme-gold {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.theme-disableAd {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.disableAd-wrapper {
  height: 474px !important;
  width: 530px !important;
  .confirm-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:104px;
    img {
      width: 230px;
      height: 78px;
    }
    img:first-child {
      margin-right: 30px;
    }
  }
}
.content-wrapper {
  margin: 8px auto 0;
  width: 636px;
  height: 1160px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding-top: 454px;
  position: relative;
}
.swiper-wrappper {
  width: 548px;
  margin: 0 auto;
  .swiper-pagination {
    position: initial;
    ::v-deep .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: rgba(255,255,255,0.5);
      margin: 0 6px;
      &-active {
        background: #fff;
      }
    }
  }
}
::v-deep .vip-packages {
  ul {
    margin: 0 30px;
  }
  li {
    width: 168px;
    height: 216px;
    border: none;
  }
  .tip {
    width: 100%;
    left: 0;
  }
  .desc {
    margin-top: 35px;
  }
  .month-price {
    margin: 17px 0 15px;
  }
  .selected {
    background: url('https://qncweb-back1.ktvsky.com/20210607/vadd/0ec8e9360e4323d7ad458db59e01eb5f.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    border: 3px solid;
    .desc, .price {
      color: #FFFFFF;
    }
    .month-price {
      color: #EDD7B3;
    }
  }
  .item-plus {
    .month-price {
      margin: 1px 0 20px;
    }
  }
  .icon-app {
    top: 121px;
  }
}
@each $name, $value in $themes {
  .theme-#{$name} {
    ::v-deep .swiper-pagination-bullet {
      background: map-get($value,bullet)!important;
      opacity: 1;
      &-active {
        background: map-get($value, bullet-active)!important;
      }
    }
  }
}
[data-theme="disableAd"] {
  .content-wrapper {
    width: 625px;
    height: 803px;
    background-image: url('https://qncweb-back1.ktvsky.com/20221011/other/1b14e55c35424856ba40794e68fa4369.png');
    padding-top: 239px;
  }
  .pay-button {
    width: 422px;
    margin: 58px auto 0;
  }
}
.close {
  width: 54px;
  position: absolute;
  right: -20px;
  top: -74px;
}
</style>
